import { jsx as _jsx } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import { BasePluginRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/base-plugin-rule/base-plugin-rule';
import { PluginRuleName } from '@modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/plugin-rule-name/plugin-rule-name';
export function SinglePluginRule({ rule, className }) {
    return (_jsx(BasePluginRule, { rule: rule, className: className, children: _jsx(Text, { bold: true, children: _jsx(PluginRuleName, { rule: rule }) }) }));
}
